'use client'

import type { AbstractIntlMessages } from 'next-intl'
import { NextIntlClientProvider, useMessages } from 'next-intl'
import { type ReactNode, useMemo } from 'react'

export function ScopedIntlProvider({
  locale,
  messages,
  children,
}: {
  locale: string
  messages: AbstractIntlMessages
  children: ReactNode
}) {
  const parentMessages = useMessages()
  const mergedMessages = useMemo(
    () => ({ ...parentMessages, ...messages }),
    [parentMessages, messages]
  )

  return (
    <NextIntlClientProvider locale={locale} messages={mergedMessages}>
      {children}
    </NextIntlClientProvider>
  )
}
